import React from "react"
import PopoverMenuHeader from "../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-header"
import PopoverMenuSeparator from "../../../../../../core/gd-components/popover-menu/popover-menu/popover-menu-separator"
import SubmenuRequestsAndFormsMenuOption from "./option"
import SubmenuRequestsAndFormsAddOption from "./add"
import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {RequestFormType} from "../../../../../../app/tools/request-forms2/const/const"
import openFormAction from "../../../../../../app/tools/request-forms2/actions/open-form"
import editFormAction from "../../../../../../app/tools/request-forms2/actions/edit-form"
import {addNewFormAction} from "../../../../../../app/tools/request-forms2/actions/add-new-form"
import togglePinFormAction from "../../../../../../app/tools/request-forms2/actions/toggle-pin"
import {ViewType} from "../../../../../../core/gd/const/views/view-type"
import ProjectView_Form from "../../../../../../core/model2/project-view/views/form/form-view"

const debug = false
// const debug = "SubmenuRequestsAndFormsMenuOptions"

type Props = {
    menuParams  : {
        project: any
    }
    hidePopover : {():void}
}

export default function SubmenuRequestsAndFormsMenuOptions(props:Props) {

    const onTogglePin = (option: any) => {
        debug && console.log(debug, 'onTogglePin', option)
        togglePinFormAction(option.id)
        props.hidePopover()
    }

    const onEditClick = (option: any) => {
        debug && console.log(debug, 'onEditClick', option)
        editFormAction(option.id)
        props.hidePopover()
    }

    const onPreviewClick = (option: any) => {
        debug && console.log(debug, 'onPreviewClick', option)

        const form = _.find(props.menuParams.project.properties.forms, form => form.id === option.id)
        openFormAction(form)
        props.hidePopover()
    }

    const onNewRequest = () => {
        debug && console.log(debug, 'onNewRequest')
        addNewFormAction(RequestFormType.REQUEST, props.menuParams.project.id)
        props.hidePopover()
    }

    const onNewForm = () => {
        debug && console.log(debug, 'onNewForm')
        addNewFormAction(RequestFormType.FORM, props.menuParams.project.id)
        props.hidePopover()
    }


    const pinnedFormsIds = _(gd.projectViews.models)
        .filter(view=>view.systemType === ViewType.PROJECT_REQUEST_FORMS)
        .map((view: ProjectView_Form)=>view.id)
        .value()

    const requestFormsMap:any = _(props.menuParams.project.properties.forms)
        .filter(form=>!pinnedFormsIds.includes(form.id))
        .groupBy(form=>form.type)
        .value()

    _.mapKeys(requestFormsMap, (value:any, key:string)=>{
        requestFormsMap[key] = _.map(value, form=>({
            id      : form.id,
            label   : form.name
        }))
    })

    debug && console.log(debug, 'render', props.menuParams.project.properties.forms, requestFormsMap)

    const showRequests      = gd.modules.requests.enabled && _.size(requestFormsMap[RequestFormType.REQUEST])>0
    const showPublicForms   = gd.modules.publicForms.enabled && _.size(requestFormsMap[RequestFormType.FORM])>0
    const canEdit           = !gd.ac.check.project.canReadOnly( props.menuParams.project.id)


    return (
        <div className="ui5-popover-menu" style={{width: 250}}>
            <VScroll containerStyle={{maxHeight:300}} minDragHeight={20}>
                {showRequests &&
                    <>
                        <PopoverMenuHeader title="Requests" />

                        {_.map(requestFormsMap[RequestFormType.REQUEST], (option:any)=>
                            <SubmenuRequestsAndFormsMenuOption key              = {option.id}
                                                               option           = {option}
                                                               canEdit          = {canEdit}
                                                               onTogglePin      = {onTogglePin}
                                                               onEditClick      = {onEditClick}
                                                               onPreviewClick   = {onPreviewClick}/>
                        )}

                        {/*<SubmenuRequestsAndFormsAddOption label="New Request" onClick={onNewRequest}/>*/}
                    </>}

                {showRequests && showPublicForms && <PopoverMenuSeparator />}

                {showPublicForms &&
                    <>
                        <PopoverMenuHeader title="Public Forms" />

                        {_.map(requestFormsMap[RequestFormType.FORM], (option:any)=>
                            <SubmenuRequestsAndFormsMenuOption key              = {option.id}
                                                               option           = {option}
                                                               canEdit          = {canEdit}
                                                               onTogglePin      = {onTogglePin}
                                                               onEditClick      = {onEditClick}
                                                               onPreviewClick   = {onPreviewClick}/>
                        )}

                        {/*<SubmenuRequestsAndFormsAddOption label="New Form" onClick={onNewForm}/>*/}
                    </>}
            </VScroll>
        </div>
    )
}